import 'css-chunk:src/applications/ReportsApp/components/Trend/Trend.module.scss';export default {
  "green": "_green_fyh0y_1",
  "red": "_red_fyh0y_5",
  "gray": "_gray_fyh0y_9",
  "white": "_white_fyh0y_13"
};